import { Spin } from 'antd'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import orderApi from '../../api/order.api'
import { userState } from '../../store/user'
import styles from '../../styles/sales.module.scss'

const OrderStatusQuickMenu = ({
  searchOptions,
  setSearchOptions,
  setDateType,
  getUserOrderList,
}) => {
  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)
  const [clickStatus, setClickStatus] = useState('')

  const [orderDeliveryStatus, setOrderDeliveryStatus] = useState({})

  useEffect(() => {
    if (clickStatus?.length) {
      if (searchOptions?.searchStatus === clickStatus) {
        getUserOrderList()
      }
    }
    if (!isLoading) {
      getOrderDeliveryStatus()
    }
  }, [clickStatus, searchOptions])

  const getOrderDeliveryStatus = async () => {
    const res = await orderApi.salesManageStatus(null, user.id)
    if (res.data.code === 200) {
      setOrderDeliveryStatus({
        ...orderDeliveryStatus,
        depositOrder: res.data.result.depositOrderCnt,
        newOrder: res.data.result.paidOrderList,
        // deliveryReady: res.data.result.deliveryReadyCnt,
        // deliveryShipping: res.data.result.deliveryShippingCnt,
        // deliveryComplete: res.data.result.deliveryCompleteCnt,
        deliveryReady: res.data.result.deliveryReadyList,
        deliveryShipping: res.data.result.deliveryShippingList,
        deliveryComplete: res.data.result.deliveryCompleteList,
        delivery12: res.data.result.deliveryReadyListPassed12,
        delivery24: res.data.result.deliveryReadyListPassed24,
        cancelRequest: res.data.result.cancelRequestList,
        returnRequest: res.data.result.returnRequestList?.length ?? 0,
        // returnComplete: res.data.result.returnCompleteList?.length ?? 0,
        exchangeRequest: res.data.result.exchangeRequestList?.length ?? 0,
      })
    }
  }

  /**
   * 배송 상태값 수
   * @param e
   */
  const handleDeliveryStatus = (e) => {
    const value = e.currentTarget.id
    if (!isLoading) {
      if (value !== 'delivery12' && value !== 'delivery24') {
        setSearchOptions({
          ...searchOptions,
          searchStatus: value,
          startDate: dayjs().subtract(14, 'days'),
          endDate: dayjs(),
          searchType: 'paymentCreatedAt',
        })
        setDateType('')
        setClickStatus(value)
      } else {
        if (value === 'delivery12') {
          if (orderDeliveryStatus?.delivery12?.length) {
            let delivery =
              orderDeliveryStatus.delivery12[
                orderDeliveryStatus?.delivery12?.length - 1
              ]?.paymentCreatedAt
            setSearchOptions({
              ...searchOptions,
              searchType: 'paymentCreatedAt',
              searchStatus: 'delivery_ready',
              startDate: dayjs(delivery),
              endDate: dayjs().subtract(12, 'hours'),
            })
            setDateType('')
          }
        } else if (value === 'delivery24') {
          if (orderDeliveryStatus?.delivery24?.length) {
            let delivery =
              orderDeliveryStatus.delivery24[
                orderDeliveryStatus?.delivery24?.length - 1
              ]?.paymentCreatedAt

            setSearchOptions({
              ...searchOptions,
              searchType: 'paymentCreatedAt',
              searchStatus: 'delivery_ready',
              startDate: dayjs(delivery),
              endDate: dayjs().subtract(24, 'hours'),
            })
            setDateType('')
          }
        }
        setClickStatus('delivery_ready')
      }
    }
  }

  return (
    <div className={`${styles.quickList}`}>
      <div className={`${styles.quickEach}`}>
        <p className={`${styles.quickTitle}`}>확인 후 먼저 처리해주세요!</p>
        <div className={`${styles.quickButtonListEach}`}>
          <button
            className={`${styles.quickButton} ${!isLoading ? styles['quick-button'] : ''}`}
            id={`delivery12`}
            onClick={handleDeliveryStatus}
            disabled={isLoading}
            style={isLoading ? {} : { cursor: 'pointer' }}
          >
            {isLoading && <Spin className={`${styles['quick-spin']}`} />}
            <p className={`${styles.quickButtonTitle}`}>
              12시간 이후 (배송준비중)
            </p>
            <p
              className={`${styles.quickButtonTitle}`}
              style={{ color: '#ff8000' }}
            >
              <b>{orderDeliveryStatus?.delivery12?.length ?? 0}</b>
            </p>
          </button>
          <button
            className={`${styles.quickButton} ${!isLoading ? styles['quick-button'] : ''}`}
            id={`delivery24`}
            onClick={handleDeliveryStatus}
            disabled={isLoading}
          >
            {isLoading && <Spin className={`${styles['quick-spin']}`} />}
            <p className={`${styles.quickButtonTitle}`}>
              24시간 이후 (배송준비중)
            </p>
            <p
              className={`${styles.quickButtonTitle}`}
              style={{ color: '#fe2b4b' }}
            >
              <b>{orderDeliveryStatus?.delivery24?.length ?? 0}</b>
            </p>
          </button>
          <button
            className={`${styles.quickButton} ${!isLoading ? styles['quick-button'] : ''}`}
            id={`cancel_request`}
            onClick={() => {
              navigate(`/order/cancel`)
            }}
            disabled={isLoading}
            style={isLoading ? {} : { cursor: 'pointer' }}
          >
            {isLoading && <Spin className={`${styles['quick-spin']}`} />}
            <p className={`${styles.quickButtonTitle}`}>취소 요청</p>
            <p className={`${styles.quickButtonTitle}`}>
              <b>{orderDeliveryStatus?.cancelRequest?.length ?? 0}</b>
            </p>
          </button>
        </div>
      </div>

      <div className={`${styles.quickEach}`}>
        <p className={`${styles.quickTitle}`}>배송 현황</p>
        <div className={`${styles.quickButtonListEach}`}>
          <button
            className={`${styles.quickButton} ${!isLoading ? styles['quick-button'] : ''}`}
            id={`paid`}
            onClick={handleDeliveryStatus}
            disabled={isLoading}
          >
            {isLoading && <Spin className={`${styles['quick-spin']}`} />}
            <p className={`${styles.quickButtonTitle}`}>
              결제완료 (발주확인 필요)
            </p>
            <p className={`${styles.quickButtonTitle}`}>
              <b>{orderDeliveryStatus?.newOrder?.length ?? 0}</b>
            </p>
          </button>

          <button
            className={`${styles.quickButton} ${!isLoading ? styles['quick-button'] : ''}`}
            id={`delivery_ready`}
            onClick={handleDeliveryStatus}
            disabled={isLoading}
          >
            {isLoading && <Spin className={`${styles['quick-spin']}`} />}
            <p className={`${styles.quickButtonTitle}`}>
              배송준비중 (발송처리 필요)
            </p>
            <p className={`${styles.quickButtonTitle}`}>
              <b>{orderDeliveryStatus?.deliveryReady?.length ?? 0}</b>
            </p>
          </button>

          <button
            className={`${styles.quickButton} ${!isLoading ? styles['quick-button'] : ''}`}
            id={`delivery_shipping`}
            onClick={handleDeliveryStatus}
            disabled={isLoading}
          >
            {isLoading && <Spin className={`${styles['quick-spin']}`} />}
            <p className={`${styles.quickButtonTitle}`}>배송중</p>
            <p className={`${styles.quickButtonTitle}`}>
              <b>{orderDeliveryStatus?.deliveryShipping?.length ?? 0}</b>
            </p>
          </button>

          <button
            className={`${styles.quickButton} ${!isLoading ? styles['quick-button'] : ''}`}
            id={`delivery_complete`}
            onClick={handleDeliveryStatus}
            disabled={isLoading}
          >
            {isLoading && <Spin className={`${styles['quick-spin']}`} />}
            <p className={`${styles.quickButtonTitle}`}>배송완료</p>
            <p className={`${styles.quickButtonTitle}`}>
              <b>{orderDeliveryStatus?.deliveryComplete?.length ?? 0}</b>
            </p>
          </button>
        </div>
      </div>
    </div>
  )
}

export default OrderStatusQuickMenu
